export const config = {
  mapItemId: 'dbcf85393c544c8fb4bf64f0ba98d68a',
  overviewMapItemId: '593e79386cdc41b1adca4e8a7ef02f58',
  curvatureMapItemId: '2a5f80aace7a492baf70e40ea462267d',
  arcgisBaseUrl: 'https://aus.gis.arcadis.com/hosting/rest/services/Hosted/Inland_Route_WFL1/FeatureServer',
  arcgisCurvatureUrl: 'https://aus.gis.arcadis.com/hosting/rest/services/Hosted/INLAND_FR_Curvature_Data/FeatureServer',
  arcgisChainageUrl: 'https://aus.gis.arcadis.com/hosting/rest/services/Hosted/INLAND_FR_Chainage/FeatureServer',
}